"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysFromWorkingDays = exports.WEEK = exports.DAY = void 0;
exports.DAY = 86400000;
exports.WEEK = exports.DAY * 7;
function isWeekDay(day) {
    return day !== 6 && day !== 0;
}
/**
 * Calculate the number of actual days
 * @param date start date to calculate the number of working days from
 * @param workingDays numnber of working days to convert to total days including weekends
 */
const daysFromWorkingDays = (date, workingDays) => {
    let days = 0;
    while (workingDays > 0) {
        days += 1;
        const dayOfWeek = new Date(date.getTime() + days * exports.DAY).getDay();
        if (isWeekDay(dayOfWeek))
            workingDays -= 1;
    }
    // If start is within weekend, extra day must be added
    if (!isWeekDay(date.getDay()))
        days++;
    return days;
};
exports.daysFromWorkingDays = daysFromWorkingDays;
